import { readBrandVar } from './speciesTheme';

// `cherry` is intentionally a getter so it resolves to the currently-active
// species brand color (--brand-700) at call time. All ApexCharts configs and
// other consumers pick up species theme changes without needing to re-render.
export const COLORS = {
  primary: '#0070f3',
  secondary: '#6c757d',
  accent: '#17a2b8',
  get cherry() {
    return readBrandVar('700', '#e60023');
  },
  red: '#dc3545',
  green: '#008000',
  lightGreen: '#70DD70',
  blue: '#0070f3',
  yellow: '#ffc107',
  orange: '#fd7e14',
  purple: '#6f42c1',
  pink: '#e83e8c',
  gray: '#6c757d',
  bitacora: '#9333EA', // Purple-600 for bitácora prices
};
